import './App.css';
import React, { Suspense } from 'react';
import { ChakraProvider, ColorModeScript, Box } from '@chakra-ui/react'
import { BrowserRouter as Router } from 'react-router-dom';
import theme from './theme';
import NavbarTopFirst from './Component/Navbar/NavbarTopFirstt';
import NavbarTopSecond from './Component/Navbar/NavbarTopSecond';
import Footer from './Component/Footer/Footer';
import ScrollToTop from './Component/ScrollToTop';
import LoadingSpinner from './Component/LoadingSpinner';
import CustomBreadcrumb from './Component/Breadcrumb';
import ThemeToggle from './Component/ThemeToggle';
import AppRoutes from './AppRoutes';

function App() {
  return (
    <ChakraProvider theme={theme}>
      <ColorModeScript initialColorMode={theme.config.initialColorMode} />
      <Router>
        <Box minH="100vh" position="relative">
          <ScrollToTop />
          <NavbarTopFirst />
          <NavbarTopSecond />
          <CustomBreadcrumb />
          <ThemeToggle />
          <Suspense fallback={<LoadingSpinner />}>
            <AppRoutes />
          </Suspense>
          <Footer />
        </Box>
      </Router>
    </ChakraProvider>
  );
}

export default App;
